import bytesLogo from '../assets/images/providers/bytes.png';
import chowNowLogo from '../assets/images/providers/chowNow.png';
import deliveryLogo from '../assets/images/providers/delivery.png';
import devourNowLogo from '../assets/images/providers/devourNow.png';
import doordashLogo from '../assets/images/providers/doordash.png';
import eatstreetLogo from '../assets/images/providers/eatstreet.png';
import gloriaLogo from '../assets/images/providers/gloria.png';
import grubhubLogo from '../assets/images/providers/grubhub.png';
import hyperzodLogo from '../assets/images/providers/hyperzod.png';
import kanekt365Logo from '../assets/images/providers/kanekt.png';
import localForYouLogo from '../assets/images/providers/localForYou.png';
import menufyLogo from '../assets/images/providers/menufy.png';
import nabeLogo from '../assets/images/providers/nabe.png';
import uberLogo from '../assets/images/providers/uber.png';
import vGrubsAILogo from '../assets/images/providers/vGrubsAI.png';
import vGrubsProviderLogo from '../assets/images/providers/vGrubsProviderLogo.png';
import cloverImage from '../assets/images/posProviders/clover.png';
import eposNowImage from '../assets/images/posProviders/eposNow.png';
import foodhubImage from '../assets/images/posProviders/foodhub.png';
import lightspeedImage from '../assets/images/posProviders/lightspeed.png';
import squareImage from '../assets/images/posProviders/square.png';
import threeSImage from '../assets/images/posProviders/threes.png';
import toastImage from '../assets/images/posProviders/toast.png';
import { PosType } from '../types/api/location.types';
import { Provider } from '../types/shared.types';
import { showsProviderIdentity } from './providerIdentity';

/*
 * The name and the logo of every marketplace (Provider) and POS (PosType).
 * Moved here unchanged from helpers.tsx, which still exports them under the
 * same names. Deliberately a LEAF module (see the note on appType.ts): no
 * 'use client', no barrels, so the marketing site can import it on the server
 * and its integrations page lists whatever the admin knows.
 */

export const providers = {
  UBER_EATS: 'ubereats',
  GRUB_HUB: 'grubhub',
  DOORDASH: 'doordash',
  VGRUBS: 'vGrubs',
  CHOW_NOW: 'chownow',
  GLORIA_FOOD: 'gloriafood',
  DELIVERY: 'delivery',
  EAT_STREET: 'eatstreet',
  MENUFY: 'menufy',
  GRUBHUBPOS: 'grubhubPos',
  DOORDASHPOS: 'doordashPos',
  LOCAL_FOR_YOU: 'localForYou',
  NABE: 'nabe',
  BYTES: 'bytes',
  KANEKT_365: 'kanekt365',
  VGRUBS_AI: 'vGrubsAI',
  HYPERZOD: 'hyperzod',
  DEVOUR_NOW: 'devourNow',
};

export const renderProviderImage = (
  provider: Provider | string,
  isOrder?: boolean
) => {
  switch (provider) {
    case providers.UBER_EATS:
      return uberLogo;
    case providers.GRUB_HUB:
      return grubhubLogo;
    case providers.VGRUBS:
      return vGrubsProviderLogo;
    case providers.DOORDASH:
      return doordashLogo;
    case providers.CHOW_NOW:
      return chowNowLogo;
    case providers.GLORIA_FOOD:
      return gloriaLogo;
    case providers.DELIVERY:
      return deliveryLogo;
    case providers.EAT_STREET:
      return eatstreetLogo;
    case providers.MENUFY:
      return menufyLogo;
    case providers.GRUBHUBPOS:
      return grubhubLogo;
    case providers.DOORDASHPOS:
      return doordashLogo;
    case providers.LOCAL_FOR_YOU:
      return localForYouLogo;
    case providers.NABE:
      return nabeLogo;
    case providers.BYTES:
      if (showsProviderIdentity()) {
        return bytesLogo;
      }
      return vGrubsAILogo;
    case providers.KANEKT_365:
      if (showsProviderIdentity()) {
        return kanekt365Logo;
      }
      return vGrubsAILogo;
    case providers.VGRUBS_AI:
      return vGrubsAILogo;
    case providers.HYPERZOD:
      return hyperzodLogo;
    case providers.DEVOUR_NOW:
      return devourNowLogo;
    default:
      break;
  }
};

export const renderProviderName = (p: Provider | string, d?: string) => {
  switch (p) {
    case Provider.ubereats:
      return 'Uber Eats';
    case Provider.doordash:
      return 'DoorDash';
    case Provider.grubhub:
      return 'Grubhub';
    case Provider.vGrubs:
      return 'vGrubs';
    case Provider.chownow:
      return 'ChowNow';
    case Provider.gloriafood:
      return 'GloriaFood';
    case Provider.delivery:
      return 'Delivery.com';
    case Provider.eatstreet:
      return 'EatStreet';
    case Provider.menufy:
      return 'Menufy';
    case Provider.grubhubPos:
      return 'Grubhub POS';
    case Provider.doordashPos:
      return 'DoorDash POS';
    case Provider.localForYou:
      return 'Local For You';
    case Provider.nabe:
      return 'Nabe';
    case Provider.bytes:
      if (showsProviderIdentity()) {
        return 'Bytes AI';
      }
      return 'vGrubs AI';
    case Provider.kanekt365:
      if (showsProviderIdentity()) {
        return 'Kanekt 365';
      }
      return 'vGrubs AI';
    case Provider.vGrubsAI:
      return 'vGrubs AI';
    case Provider.hyperzod:
      return 'Hyperzod';
    case Provider.devourNow:
      return 'DevourNow';

    default:
      return d;
  }
};

export const renderPosImage = (p: PosType | string) => {
  switch (p) {
    case PosType.lightspeedO:
      return lightspeedImage;
    case PosType.lightspeedK:
      return lightspeedImage;
    case PosType.foodhub:
      return foodhubImage;
    case PosType.square:
      return squareImage;
    case PosType.toast:
      return toastImage;
    case PosType.clover:
      return cloverImage;
    case PosType.threeS:
      return threeSImage;
    case PosType.eposNow:
      return eposNowImage;
    default:
      return '';
  }
};

export const renderPosName = (p: PosType | string, d?: string) => {
  switch (p) {
    case PosType.lightspeedO:
      return 'Lightspeed O';
    case PosType.lightspeedK:
      return 'Lightspeed K';
    case PosType.foodhub:
      return 'FoodHub';
    case PosType.square:
      return 'Square';
    case PosType.toast:
      return 'Toast';
    case PosType.clover:
      return 'Clover';
    case PosType.threeS:
      return 'ThreeS';
    case PosType.eposNow:
      return 'ePOS Now';
    default:
      return d;
  }
};
